<render-layout-slot
  [layout]="layout"
  [slot]="'1'"
></render-layout-slot>
